module.exports = __webpack_public_path__ + "static/fonts/nucleo-icons.8224e01.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.eot
// module id = 8J57
// module chunks = 4